import { useRevealOnScroll } from "../../lib/useRevealOnScroll";
import { cn } from "../../lib/utils";

export function KpiCard({
  label,
  value,
  suffix,
  sub,
  valueColor,
  accent,
  icon,
  children
}) {
  /* O tom default é a cor de DADO, não a de marca: o filete e o ícone do KPI
     descrevem a métrica, não a plataforma. Ver o cabeçalho de tokens.css. */
  const tone = accent ?? "var(--color-data)";
  const { ref, visible } = useRevealOnScroll();
  return (
    <div
      ref={ref}
      className={cn(
        "group relative overflow-hidden rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-surface)]/92 p-4 shadow-[var(--shadow-card)] backdrop-blur-sm transition-all duration-200 hover:-translate-y-1 hover:border-[var(--color-border-strong)] hover:shadow-[var(--shadow-card-hover)] sm:p-[18px]",
        visible ? "animate-card-in" : "card-pending"
      )}
      style={{ "--tone": tone }}
    >
      {/* filete de acento no topo */}
      <span
        className="absolute inset-x-0 top-0 h-[3px] opacity-75 transition-opacity group-hover:opacity-100"
        style={{ background: tone }}
      />

      {/* farol: luz descendo a partir do filete, na cor do acento */}
      <span
        className="pointer-events-none absolute inset-x-0 top-0 h-1/3 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background: `linear-gradient(to bottom, color-mix(in srgb, ${tone} 10%, transparent), transparent)`
        }}
      />

      <div className="relative mb-2 flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.07em] text-[var(--color-ink-faint)]">
          {label}
        </span>
        {icon && (
          <span className="grid h-9 w-9 place-items-center rounded-xl border border-current/10 bg-[color-mix(in_srgb,var(--tone)_13%,transparent)] text-[var(--tone)] transition-all duration-300 group-hover:scale-105 group-hover:bg-[color-mix(in_srgb,var(--tone)_34%,transparent)]">
            {icon}
          </span>
        )}
      </div>
      {children ? (
        <div className="relative">{children}</div>
      ) : (
        <>
          <div
            className={cn(
              "tnum text-[28px] font-bold leading-none tracking-tight sm:text-[30px]"
            )}
            style={{ color: valueColor ?? "var(--color-ink)" }}
          >
            {value}
            {suffix && (
              <span className="ml-0.5 text-[14px] font-normal text-[var(--color-ink-faint)]">
                {suffix}
              </span>
            )}
          </div>
          {sub && (
            <div className="mt-2 text-[11.5px] leading-snug text-[var(--color-ink-faint)]">
              {sub}
            </div>
          )}
        </>
      )}
    </div>
  );
}
